import { useEffect } from 'react'
import { BrowserRouter, useRoutes } from 'react-router-dom'
import { ConfigProvider } from 'antd-mobile'
import { getAntdLocale } from '@/lang/antd_locale_config'
import routes from '@/router'

function App() {
  const RouteElement = () => {
    const element = useRoutes([...routes])
    return element
  }

  useEffect(() => {
    if (import.meta.env.VITE_APP_ENV !== 'production') {
      new window.VConsole()
    }
  }, [])

  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <ConfigProvider locale={getAntdLocale()}>
        <RouteElement />
      </ConfigProvider>
    </BrowserRouter>
  )
}

export default App
